"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/SaleTag` instead */
export const SaleTag = createSVGIcon(
  <>
    <path
      d="m21.122 15.667-5.455 5.455a1.285 1.285 0 0 1-1.819 0L2.69 9.963a.65.65 0 0 1-.187-.497L2.9 3.501a.645.645 0 0 1 .6-.6l5.965-.398a.65.65 0 0 1 .497.187l11.159 11.158a1.285 1.285 0 0 1 0 1.819Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.232 8.09a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SaleTag",
  {
    viewBox: "0 0 24 24",
    titleAccess: "SaleTag",
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  }
);
